import { TNumericOperator } from "../../../Components/NumericConditionPicker";
import { TStateOperator } from "../../../Components/StateConditionPicker";
import { TTimestampUnit } from "../../../Components/TimestampConditionPicker";

export type TNoneCondition = {
  type: "none";
};

export const defaultNoneCondition: TNoneCondition = {
  type: "none",
};

export type TNumericCondition = {
  type: "numeric";
  device_id?: number;
  attribute?: string;
  operator: TNumericOperator;
  value: number;
};

export const defaultNumericCondition: TNumericCondition = {
  type: "numeric",
  operator: "=",
  value: 0,
};

export type TStateChangeCondition = {
  type: "state_change";
  state: string;
  previous_state: string;
};

export const defaultStateChangeCondition: TStateChangeCondition = {
  type: "state_change",
  state: "<any>",
  previous_state: "<any>",
};

export type TStateCondition = {
  type: "state";
  device_id?: number;
  attribute?: string;
  operator: TStateOperator;
  state: string;
};

export const defaultStateCondition: TStateCondition = {
  type: "state",
  operator: "=",
  state: "",
};

export type TAndCondition = {
  type: "and";
  conditions: TCondition[];
};

export const defaultAndCondition: TAndCondition = {
  type: "and",
  conditions: [defaultNoneCondition, defaultNoneCondition],
};

export type TOrCondition = {
  type: "or";
  conditions: TCondition[];
};

export const defaultOrCondition: TOrCondition = {
  type: "or",
  conditions: [defaultNoneCondition, defaultNoneCondition],
};

export type TTimestampCondition = {
  type: "timestamp";
  device_id?: number;
  attribute?: string;
  value: number;
  unit: TTimestampUnit;
};

export const defaultTimestampCondition: TTimestampCondition = {
  type: "timestamp",
  value: 0,
  unit: "hours",
};

export type TCondition =
  | TNumericCondition
  | TStateCondition
  | TStateChangeCondition
  | TNoneCondition
  | TAndCondition
  | TOrCondition
  | TTimestampCondition;
